import React from "react";
import SocialsList1 from "components/SocialsList1/SocialsList1";
import image from "../../images/logo-podobno.png";
import LogoFooter from "components/Logo/LogoFooter";

const widgetMenus = [
  {
    id: "5",
    menus: [
      { href: "/about", label: "O nas" },
      { href: "/rodo", label: "Polityka prywatności" },
      { href: "/contact", label: "Kontakt" },
      { href: "/regulamin", label: "Regulamin" },
    ],
  },
  {
    id: "1",
    menus: [
      // { href: "/kuchnia", label: "Kuchnia regionalna" },
      // { href: "/horoskop", label: "Horoskop" },
      {
        href: "https://www.facebook.com/profile.php?id=100094750866279",
        label: (
          <SocialsList1 className="flex items-center space-x-3" />
        ),
      },
    ],
  },
];

const Footer = () => {
  return (
    <footer
      className="bg-black border-t border-neutral-800 py-16"
    >
      <div className="container">

        {/* GŁÓWNY UKŁAD */}
        <div className="flex flex-col items-start">

          {/* LOGO */}
          <div className="mb-10">
            <LogoFooter />
          </div>

          {/* MENU */}
          <div className="flex flex-column gap-8">

            {widgetMenus.map((menu) => (
              <div key={menu.id}>
                <ul className="flex flex-col gap-3">

                  {menu.menus.map((item, index) => (
                    <li key={index}>

                      <a
                        href={item.href}
                        className="text-white text-[18px] hover:opacity-70 transition-opacity duration-200"
                      >
                        {item.label}
                      </a>

                    </li>
                  ))}

                </ul>
              </div>
            ))}

          </div>

          {/* STOPKA */}
          <div className="flex items-center gap-2 mt-7">

            <p className="text-white text-[18px]">
              Projekt i wdrożenie
            </p>

            <a
            style={{color:"white"}}
              href="https://podobno.pl"
              target="_blank"
              rel="noreferrer"
            >
              podobno.pl
            </a>

          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;